import $ from 'jquery';

var elements = stripe.elements();

var style = {
  base: {
    fontSize: '16px',
    lineHeight: '24px'
  }
};

var card = elements.create('card', { style });

$(() => {
  const form = document.getElementById('subscriptions-form') || document.getElementById('gifts-form');

  if ($("#card-options").length > 0) {
    form.addEventListener('submit', onFormSubmit);

    card.addEventListener('change', onCardChange);
    card.mount("#card-element");
  }

  function onCardChange(event) {
    var displayError = document.getElementById('card-errors');
    if (event.error) {
      displayError.textContent = event.error.message;
    } else {
      displayError.textContent = '';
    }
  };

  function onFormSubmit(event) {
    event.preventDefault();

    const $submit = $("#submit-button");

    stripe.createToken(card).then(function(result) {
      if (result.error) {
        // Inform the user if there was an error
        var errorElement = document.getElementById('card-errors');
        errorElement.textContent = result.error.message;
      } else {
        // Send the token to your server
        stripeTokenHandler(result.token);
      }
    });
  };

  function stripeTokenHandler(token) {
    // Insert the token ID into the form so it gets submitted to the server
    var hiddenInput = document.createElement('input');
    hiddenInput.setAttribute('type', 'hidden');
    hiddenInput.setAttribute('name', 'stripeToken');
    hiddenInput.setAttribute('value', token.id);
    form.appendChild(hiddenInput);

    // Submit the form
    form.submit();
  };
});